export default function uniqueid () {
	return 'id-' + Math.random().toString(36).substr(2, 16)
}



// WEBPACK FOOTER //
// ./src/utils/uniqueid.js